import { render, staticRenderFns } from "./CallForHelpList.vue?vue&type=template&id=748da8a7&"
import script from "./CallForHelpList.vue?vue&type=script&lang=js&"
export * from "./CallForHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports